var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 18,
    viewBox: "0 0 54 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5014 17.4571H8.82775L5.32309 3.80806C5.15674 3.18021 4.80354 2.62515 4.28399 2.36354C2.9874 1.70611 1.55864 1.1829 0 0.919014V0.393525H7.52889C8.56798 0.393525 9.3473 1.1829 9.47719 2.09966L11.2956 11.9452L15.967 0.393525H20.5107L13.5014 17.4571ZM23.1053 17.4571H18.6914L22.326 0.393524H26.7398L23.1053 17.4571ZM32.4546 5.12067C32.5845 4.20164 33.3638 3.67615 34.2731 3.67615C35.7018 3.54421 37.2582 3.80809 38.557 4.46324L39.3364 0.789371C38.0375 0.263882 36.6087 0 35.3121 0C31.0282 0 27.9109 2.36356 27.9109 5.64389C27.9109 8.13939 30.1189 9.4497 31.6776 10.2391C33.3638 11.0262 34.0133 11.5517 33.8834 12.3388C33.8834 13.5194 32.5845 14.0449 31.2879 14.0449C29.7293 14.0449 28.1706 13.6513 26.7442 12.9939L25.9648 16.6701C27.5235 17.3252 29.2097 17.5891 30.7684 17.5891C35.5719 17.7188 38.557 15.3575 38.557 11.8133C38.557 7.35002 32.4546 7.08841 32.4546 5.12067ZM53.9992 17.4571L50.4945 0.393524H46.7301C45.9508 0.393524 45.1714 0.919013 44.9117 1.70611L38.4219 17.4571H42.9656L43.8726 14.9639H49.4554L49.975 17.4571H53.9992ZM47.3848 4.98874L48.6814 11.4197H45.0469L47.3848 4.98874Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment6);
export default __webpack_public_path__ + "static/media/payment6.b86b0659832bc689edaa4b861d70f6e3.svg";
export { ForwardRef as ReactComponent };